/**
 * Base model class with common functionality for all models
 */
export default class BaseModel {
  /**
   * Tạo một instance mới của DemoCar
   * @param {string|null} data.id - ID của model
   * @param {Date} data.createdAt - Ngày tạo
   * @param {Date} data.updatedAt - Ngày cập nhật
   */
  constructor(
    data = {
      id: null,
      createdAt: null,
      updatedAt: null,
    },
  ) {
    this.id = data.id;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }
  /**
   * Chuyển đổi từ dữ liệu JSON thành đối tượng model
   * @param {Object} json - Dữ liệu JSON
   * @param {Function} ModelClass - Class constructor của model
   * @returns {Object} - Đối tượng model
   */
  static fromJson(json, ModelClass) {
    if (!json) {
      return null;
    }
    return new ModelClass(json);
  }

  /**
   * Chuyển đổi từ danh sách JSON thành danh sách đối tượng model
   * @param {Array} jsonArray - Mảng dữ liệu JSON
   * @param {Function} ModelClass - Class constructor của model
   * @returns {Array<Object>} - Mảng đối tượng model
   */
  static fromJsonArray(jsonArray, ModelClass) {
    if (!Array.isArray(jsonArray) || !jsonArray) {
      return [];
    }
    return jsonArray.map((json) => BaseModel.fromJson(json, ModelClass));
  }
}
